import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls window to the top whenever the pathname changes (route navigation).
// Anchor links (#section) are preserved and not scrolled.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
}
